import * as React from 'react';
import { parseHtml } from '@grandvisionhq/lib-utils-html';
import { ItemList } from '../components/ItemList.js';

const ConsentsContainer = ({ onChange , selectedConsents , consents  })=>{
    const getItemLabel = React.useCallback((item)=>parseHtml(item.title)
    , []);
    const getItemIdentifier = React.useCallback((item)=>item.value
    , []);
    const getItemErrorMessage = React.useCallback((item)=>{
        return (item === null || item === void 0 ? void 0 : item.errorMessage) || '';
    }, []);
    const shouldItemValidate = React.useCallback((item)=>{
        return (item === null || item === void 0 ? void 0 : item.shouldValidate) || false;
    }, []);
    if (!(consents === null || consents === void 0 ? void 0 : consents.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ItemList, {
        getItemIdentifier: getItemIdentifier,
        getItemLabel: getItemLabel,
        getItemErrorMessage: getItemErrorMessage,
        shouldItemValidate: shouldItemValidate,
        idPrefix: "consents__",
        items: consents,
        onChange: onChange,
        selectedItems: selectedConsents !== null && selectedConsents !== void 0 ? selectedConsents : []
    });
};

export { ConsentsContainer };
//# sourceMappingURL=ConsentsContainer.js.map
